import { render, staticRenderFns } from "./PersonalInfoView.vue?vue&type=template&id=498190ec&scoped=true"
import script from "./PersonalInfoView.vue?vue&type=script&lang=js"
export * from "./PersonalInfoView.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoView.vue?vue&type=style&index=0&id=498190ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498190ec",
  null
  
)

export default component.exports